// Per-user storage: routes all localStorage.* calls through the signed-in user namespace.
import { scopedStorage as localStorage } from "../services/userStorage";
import React, { useState } from 'react';
import { ArrowRight, BookOpen, Check, Database, Feather, Save, Sparkles } from 'lucide-react';
import { Link } from 'react-router';
import { getBibleReaderPath } from '../services/bibleReaderService';
import { getDailyVerse } from '../services/dailyContentService';

const BibleVerseOfTheDay = () => {
    const [passage] = useState(() => getDailyVerse());
    const reflectionKey = `daily_verse_reflection_${passage.date}`;
    const [reflection, setReflection] = useState(() => localStorage.getItem(reflectionKey) || '');
    const [saved, setSaved] = useState(false);

    const saveReflection = () => {
        localStorage.setItem(reflectionKey, reflection.trim());
        setSaved(true);
        window.setTimeout(() => setSaved(false), 2500);
    };

    return (
        <div className="daily-verse-experience">
            <article className="daily-verse-card">
                <div className="daily-verse-card-topline">
                    <p><Sparkles size={14} /> Today’s verse</p>
                    <span><Database size={14} /> Verified WEB text</span>
                </div>
                <h1>{passage.reference}</h1>
                <blockquote>“{passage.text}”</blockquote>
                <Link to={getBibleReaderPath(passage.reference)}>
                    Read the full chapter <ArrowRight size={17} />
                </Link>
                <span className="daily-verse-orbit" aria-hidden="true"><BookOpen size={26} /></span>
            </article>

            <section className="daily-verse-reflection">
                <div>
                    <span><Feather size={20} /></span>
                    <div><p className="shared-kicker">Carry it with you</p><h2>What stands out to you in today’s Scripture?</h2></div>
                </div>
                <textarea
                    aria-label="Today's verse reflection"
                    rows="5"
                    value={reflection}
                    onChange={(event) => setReflection(event.target.value)}
                    placeholder="Write one thought, prayer, or phrase you want to remember..."
                />
                <button onClick={saveReflection} disabled={!reflection.trim()}>
                    {saved ? <Check size={18} /> : <Save size={18} />}
                    {saved ? 'Reflection saved' : 'Save today’s reflection'}
                </button>
            </section>
        </div>
    );
};

export default BibleVerseOfTheDay;
